export default __webpack_public_path__ + "static/media/starwarsLogo.ee8b73bb.png";